
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiLguK3guK3guIHguYHguJrguJrguJrguJkgQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiLguK3guK3guIHguYHguJrguJrguJrguJkgQ2FudmEifQ==!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNhaW4gZGkgQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNhaW4gZGkgQ2FudmEifQ==!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiLguK3guK3guIHguYHguJrguJrguJrguJkgQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiLguK3guK3guIHguYHguJrguJrguJrguJkgQ2FudmEifQ==!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNhaW4gZGkgQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNhaW4gZGkgQ2FudmEifQ==!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJEZXNpZ24gb24gQ2FudmEifQ==!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJb4biK4bq94bq94bq9xaHDrMOsw6zEo+C4geC4teC5iSDDtsO2w7bguIHguLXguYkgw4fEg8SDxIPguIHguLXguYnhub3Eg8SDxINdIn0=!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../node_modules/virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJEZXNpZ24gb24gQ2FudmEiOiJb4biK4bq94bq94bq9xaHDrMOsw6zEo+C4geC4teC5iSDDtsO2w7bguIHguLXguYkgw4fEg8SDxIPguIHguLXguYnhub3Eg8SDxINdIn0=!"
        )
      )
      });
  
      export { translations as default };
    